var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95435 5.48071H5.22998V4.61865H3.50537V7.20508H17.3003V4.61865H15.5762V5.48071H13.8518V4.61865H6.95435V5.48071ZM17.3003 8.92944H3.50537V17.5514H17.3003V8.92944ZM13.8518 2.89417H6.95435V2.03198H5.22998V2.89417H3.50562C2.55327 2.89417 1.78125 3.66619 1.78125 4.61853V17.5513C1.78125 18.5036 2.55327 19.2756 3.50562 19.2756H17.3005C18.2529 19.2756 19.0249 18.5036 19.0249 17.5513V4.61853C19.0249 3.66619 18.2529 2.89417 17.3005 2.89417H15.5762V2.03198H13.8518V2.89417ZM6.09216 12.3782V10.6538H7.81653V12.3782H6.09216ZM9.54089 12.3782H11.2653V10.6538H9.54089V12.3782ZM12.9896 12.3782V10.6538H14.714V12.3782H12.9896ZM6.09216 14.1025V15.8269H7.81653V14.1025H6.09216ZM11.2653 15.8269H9.54089V14.1025H11.2653V15.8269Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.cc395fe97bf688f969f78f5222d29b99.svg";
export { ForwardRef as ReactComponent };